(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[885],{

/***/ 40885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ scrollBtn; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./hooks/index.js + 2 modules
var hooks = __webpack_require__(84431);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/scrollBtn/ScrollBtn.module.scss
var ScrollBtn_module = __webpack_require__(71376);
var ScrollBtn_module_default = /*#__PURE__*/__webpack_require__.n(ScrollBtn_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/scrollBtn/ScrollBtn.js








var ScrollBtn = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var _ref$isWishlist = _ref.isWishlist,
      isWishlist = _ref$isWishlist === void 0 ? false : _ref$isWishlist;

  var _useState = (0,react.useState)(),
      triggerRef = _useState[0],
      setTriggerRef = _useState[1];

  var _useVisibility = (0,hooks/* useVisibility */.iJ)(triggerRef),
      visible = _useVisibility.visible;

  var onClick = (0,react.useCallback)(function () {
    modules/* animateScroll.scrollToTop */.NY.scrollToTop();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: (0,clsx_m/* default */.Z)((ScrollBtn_module_default()).scrollButton, visible && (ScrollBtn_module_default()).scrollButtonVisible, isWishlist && (ScrollBtn_module_default()).wishlistStyle),
      onClick: onClick
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ScrollBtn_module_default()).trigger,
      ref: setTriggerRef
    })]
  });
});
/* harmony default export */ var scrollBtn_ScrollBtn = (ScrollBtn);
;// CONCATENATED MODULE: ./components/scrollBtn/index.js

/* harmony default export */ var scrollBtn = (scrollBtn_ScrollBtn);

/***/ }),

/***/ 71376:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scrollButton":"ScrollBtn_scrollButton__ySPwO","scrollButtonVisible":"ScrollBtn_scrollButtonVisible___vH2_","trigger":"ScrollBtn_trigger__LJ8wD","wishlistStyle":"ScrollBtn_wishlistStyle__kbXwo","load":"ScrollBtn_load__6_Ycg"};

/***/ })

}]);